import React from 'react';
import { IconProps } from '.';

export const LearnerIllustration: React.FC<IconProps> = (props) => {
  return (
    <svg
      width="33"
      stroke="currentColor"
      fill="none"
      height="32"
      viewBox="0 0 33 32"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.66669 7.99998C5.66669 7.29274 5.94764 6.61446 6.44774 6.11436C6.94783 5.61426 7.62611 5.33331 8.33335 5.33331H24.3334C25.0406 5.33331 25.7189 5.61426 26.219 6.11436C26.7191 6.61446 27 7.29274 27 7.99998V24C27 24.7072 26.7191 25.3855 26.219 25.8856C25.7189 26.3857 25.0406 26.6666 24.3334 26.6666H8.33335C7.62611 26.6666 6.94783 26.3857 6.44774 25.8856C5.94764 25.3855 5.66669 24.7072 5.66669 24V7.99998Z"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M11.3334 10V21H21.3334" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

LearnerIllustration.displayName = 'LearnerIllustration';
